export default {
  title: "Онлайн-каталог",
  tabs: {
    products: "Товары и услуги",
    categories: "Категории",
  },
  buttons: {
    qrCode: "QR - код",
    create: "Создать",
  },
  modals: {
    limit: {
      title: "Вы создали максимальное количество товаров на вашем тарифе",
      subtitle: "Чтобы создать больше товаров, повысьте тариф.",
      cancel: "Отмена",
      toTariffs: "К тарифам",
    },
  },
  statuses: {
    allProducts: "Все товары",
    allCategories: "Все категории",
    confirmed: "Подтвержденные",
    moderation: "На модерации",
    rejected: "Отклоненные",
    basic: "Базовые",
  },
  emptyState: {
    products: {
      noTradingPoints: {
        title: "Товаров в онлайн-каталоге пока нет",
        description:
          "Сначала создайте торговую точку, затем можно будет добавить товары",
        buttonText: "К торговым точкам",
      },
      noProducts: {
        title: "Товаров в онлайн-каталоге пока нет",
        buttonText: "Создать товар",
      },
    },
    categories: {
      title: "Данных пока нет",
      description:
        "Они появятся здесь после создания товара и прикрепления его к одной из базовых категорий. Или после создания пользовательской категории.",
      buttonText: "Создать категорию",
    },
  },
  formErrors: {
    empty: "Поле не может быть пустым",
    price: "Необходимо указать значение больше 0",
    discount: "Необходимо указать значение меньше цены без скидки",
  },
  exitModal: {
    creating: {
      title: "Отменить создание товара?",
      subtitle:
        "Внесенная информация о товаре не сохранится. Чтобы вернуться к редактированию, нажмите «Назад».",
      backButton: "Назад",
      confirmButton: "Да, отменить",
    },
    editing: {
      title: "Удалить внесенные изменения?",
      subtitle:
        "Если необходимо их сохранить, вернитесь назад. Иначе все внесенные изменения не будут применены. В карточке товара отобразятся ранее сохраненные данные.",
      backButton: "Вернуться и сохранить",
      confirmButton: "Удалить",
    },
  },
  categoryEditModal: {
    title: {
      rejected: "Категория отклонена модератором",
      default: "Укажите название категории",
    },
    subtitle: {
      rejected: "Измените название и отправьте категорию на модерацию.",
      rejectedWithMessage:
        "Измените название и отправьте категорию на модерацию.",
      default:
        "Категория станет доступна к выбору при создании новых товаров и отобразиться с указанным названием в RC PAY только после прохождения модерации.",
    },
    buttons: {
      cancel: "Отмена",
      sendForModeration: "На модерацию",
    },
    notification: {
      success: "Категория отправлена на модерацию",
    },
  },
  categoryDeleteModal: {
    title: "Уверены, что хотите удалить категорию «{name}»?",
    subtitle:
      "Товарам, которые к ней относятся, будет присвоено базовое значение «Без категории»",
    buttons: {
      cancel: "Отмена",
      delete: "Удалить",
    },
    notification: {
      deleted: "Категория удалена",
    },
  },
  productCard: {
    labels: {
      name: "Название товара",
      category: "Категория",
      measurementUnit: "Единица измерения",
      price: "Цена, {currency}",
      discountPrice: "Цена со скидкой, {currency}",
      sku: "Артикул",
      barcode: "Штрихкод",
      description: "Описание",
      tradingPointsVisibility: "Отображение в торговых точках",
      productImages: "Изображения товара",
      showInCatalog: "Отображать товар в Онлайн-каталоге",
      showInCatalogDescription:
        "Товар будет отображен в RC PAY в Онлайн-каталог выбранных торговых точек после прохождения модерации.",
    },
    placeholders: {
      selectCategory: "Выберите категорию",
      selectMeasurementUnit: "Выберите единицу измерения",
      sku: "до 30 символов",
      selectTradingPoints: "Выберите торговые точки",
    },
    buttons: {
      cancel: "Отменить",
    },
    notifications: {
      fillRequiredFields: "Заполните корректно все обязательные поля",
    },
    moderationMessage: {
      title: "Сообщение от модерации",
    },
    measurementUnits: {
      none: "Без единиц измерения",
    },
    imageRequirements: {
      aspectRatio: "Соотношение сторон изображения — 1:1",
      fileTypes: "JPEG, JPG, PNG — до 5 файлов не более 10 Мб каждый",
    },
    imageCropper: {
      subtitle:
        "Выбранная область будет отображаться в карточке товара в Онлайн-каталоге в RC PAY.",
    },
  },
  productsTableHeader: {
    columns: {
      name: "Наименование",
      category: "Категория",
      price: "Цена",
      status: "Статус",
    },
  },
  productsDeleteModal: {
    title: "Уверены, что хотите удалить указанный товар?",
    buttons: {
      cancel: "Отмена",
      delete: "Удалить",
    },
  },
  productsQRModal: {
    title: "QR-код на меню",
    subtitle:
      "Выберите торговую точку, QR-код на онлайн-каталог которой хотите скачать",
    tradingPoint: "Торговая точка",
    downloadButton: "Скачать QR-код",
  },
  productsSaveModal: {
    title: "Некоторые из внесенных изменений требуют модерации",
    subtitle:
      "В карточке товара, отображаемой в RC PAY, они обновятся только после проверки и подтверждения модератором.",
    buttons: {
      cancel: "Отмена",
      sendForModeration: "На модерацию",
    },
  },
  productVisible: {
    messages: {
      visible: "Отображен в RC PAY",
      hidden: "Скрыт в RC PAY",
    },
  },
  categoriesFilters: {
    sort: {
      newFirst: "Сначала новые созданные",
      alphabeticalAsc: "По названию от А до Я",
      alphabeticalDesc: "По названию от Я до А",
      productsCountAsc: "Сначала меньше товаров",
      productsCountDesc: "Сначала больше товаров",
    },
    buttons: {
      create: "Создать",
    },
    search: {
      placeholder: "Поиск по категориям",
    },
    status: {
      label: "Статус категории",
    },
  },
  productFilters: {
    sort: {
      newFirst: "Сначала новые созданные",
      alphabeticalAsc: "По названию от А до Я",
      alphabeticalDesc: "По названию от Я до А",
      priceAsc: "Цена по возрастанию",
      priceDesc: "Цена по убыванию",
    },
    buttons: {
      create: "Создать",
    },
    search: {
      placeholder: "Поиск",
    },
    labels: {
      category: "Категория",
      tradingPoints: "Торговые точки",
      status: "Статус",
    },
  },
  productDrawer: {
    title: {
      edit: "Информация о товаре",
      create: "Создание товара",
    },
    saveButton: {
      saveAndExit: "Сохранить и выйти",
      sendForModeration: "На модерацию",
    },
    errors: {
      imageUpload:
        "Некоторые изображения не получилось обработать. Попробуйте загрузить другие.",
    },
  },
  categoryGroup: {
    system: "Основные",
    confirm: "Подтвержденные",
    moderation: "На модерации",
    reject: "Отклоненные",
  },
  sysCategory: {
    autoLubrication: "Автомобильная смазка",
    autoDisks: "Автомобильные диски",
    autoOils: "Автомобильные моторные масла",
    autoTires: "Автомобильные шины",
    carWash: "Автомойка",
    accumulator: "Аккумулятор",
    accessories: "Аксессуары",
    antifreeze: "Антифриз",
    rentMovableProperty: "Аренда движимого имущества",
    rentImmovableProperty: "Аренда недвижимого имущества",
    householdAppliances: "Бытовая техника",
    householdChemicals: "Бытовая химия",
    sideDishes: "Гарниры",
    gelSystems: "Гелевые системы",
    hotDishes: "Горячее",
    grill: "Гриль",
    dysenfyingDetergents: "Дезинфицирующие моющие средства",
    deserts: "Десерты",
    forChildren: "Для детей",
    forAnimals: "Для животных",
    forHoliday: "Для праздника",
    homeTextiles: "Домашний текстиль",
    breakfast: "Завтраки",
    snacks: "Закуски",
    spareParts: "Запчасти",
    health: "Здоровье",
    toys: "Игрушки",
    furnitureManufacturing: "Изготовление мебели",
    medicals: "Изделия медицинского назначения",
    instruments: "Инструменты",
    chancellery: "Канцелярия",
    books: "Книги",
    laboratoryUtensils: "Лабораторная посуда",
    furniture: "Мебель",
    medicalInstruments: "Медицинские инструменты",
    medicalTechDevices: "Медицинские технические приборы",
    perennialFlowers: "Многолетние цветы",
    drinks: "Напитки",
    equipment: "Оборудование",
    shoes: "Обувь",
    clothes: "Одежда",
    parfumeCosmetic: "Парфюмерия и косметика",
    pasta: "Паста",
    pizza: "Пицца",
    gifts: "Подарки",
    printingProducts: "Полиграфическая продукция",
    dishes: "Посуда",
    products: "Продукты",
    foodProducts: "Продукты питания",
    repairFinishingWork: "Ремонтные/отделочные работы",
    gardenFertilizers: "Садовые удобрения",
    seedlings: "Саженцы",
    salads: "Салаты",
    sauces: "Соусы",
    sport: "Спорт",
    hairCareProducts: "Средства по уходу за волосами",
    buildingMaterials: "Строительные материалы",
    building: "Строительство",
    soups: "Супы",
    gardenProducts: "Товары для садоводства",
    brakeFluid: "Тормозная жидкость",
    tosol: "Тосол",
    services: "Услуги",
    insuranceServices: "Услуги страхования",
    care: "Уход",
    filter: "Фильтр",
    fitnessLanch: "Фитнес обеды",
    photoProducts: "Фототовары",
    chemicalReagents: "Химические реактивы",
    bread: "Хлеб",
    hobbies: "Хобби",
    flowers: "Цветы",
    tireRepair: "Шиномонтаж",
    ecoWashProducts: "Экомоющие средства",
    electric: "Электроника",
    legalServices: "Юридические услуги",
    noCategory: "Без категории",
  },

  hideInRcPay: "Скрыть {str}в RC PAY",
  showInRcPay: "Отобразить {str}в RC PAY",
  removeProduct: "Удалить товар",
  checkProducts: "Посмотреть товары",
  changeNaming: "Изменить название",
  removeCategory: "Удалить категорию",
  product: "Товар",
  message: {
    productHidden: "Товар скрыт в RC PAY",
    productShown: "Товар отображен в RC PAY",
  },
  categoryName: "Название категории",
  productsAmount: "Кол-во товаров",
  status: "Статус",
};
